<template>
  <b-button type="is-primary" :loading="is_loading" @click="onClick">
    <slot></slot>
  </b-button>
</template>
<script>
export default {
  name: "cagura-button",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      is_loading: false,
    };
  },
  watch: {
    loading: function (val) {
      this.is_loading = val;
    },
  },
  mounted() {
    let vm = this;
    vm.is_loading = vm.loading;
  },
  methods: {
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-btn-cagura {
  position: relative;
}
.loader {
  border-radius: 5px;
}
</style>
